import i18n from '@/i18n'

export const preventBodyScroll = value => {
  const bodyClasses = document.getElementsByTagName('html')[0].classList
  if (value) {
    bodyClasses.add('prevent-body-scroll')
  } else {
    bodyClasses.remove('prevent-body-scroll')
  }
}

export const parseDate = value => {
  if (!value) return value

  try {
    const date = new Date(value)
    if (isNaN(date.getTime())) return value

    const month = date.toLocaleString('en-CA', {
      month: 'long',
      timeZone: 'UTC'
    })
    const day = date.toLocaleString('en-CA', {
      day: 'numeric',
      timeZone: 'UTC'
    })
    const year = date.toLocaleString('en-CA', {
      year: 'numeric',
      timeZone: 'UTC'
    })
    /* Month is formatted in en-CA then translated - every month name is a key in
       the locale catalogues, so dropping this left French dates in English. */
    return `${i18n.global.t(month)} ${day}, ${year}`
  } catch (error) {
    console.warn('Error parsing date:', error)
    return value
  }
}

export const downloadTrigger = (url, name) => {
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', name)
  link.click()
}

export const printTrigger = url => {
  const _iFrame = document.createElement('iframe')
  _iFrame.setAttribute('src', url)
  _iFrame.setAttribute('class', 'hidden')
  _iFrame.onload = () => {
    _iFrame.contentWindow.print()
  }
  document.querySelector('main > div').append(_iFrame)
}

export const getBrowserLocale = () => {
  return navigator.userLanguage || navigator.language
}

export const removeFBSlash = str => {
  if (str[0] === '/') str = str.substring(1)
  if (str[str.length - 1] === '/') str = str.slice(0, -1)
  return str
}

export const detectEnvironment = () => {
  const host = window.location.host
  const currentEnv = process.env.NODE_ENV

  if (host.includes('investor-ee') && host.includes('raisr.com')) return 'micro'
  return currentEnv
}
